import { initSentry } from "./sentry";
initSentry();      // ← must be first so Sentry captures any import-time errors

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { initAnalytics } from "./analytics";

initAnalytics();   // ← BEFORE render

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);